// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../context/AuthContext';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const AdminDashboard = () => {
//     const { user, token, logout } = useAuth();
//     const navigate = useNavigate();
//     const [loans, setLoans] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchLoans = async () => {
//             try {
//                 const token = localStorage.getItem('token');
//                 // console.log('Token:', token);

//                 if (!token) {
//                     console.error('No token found');
//                     return;
//                 }

//                 const response = await axios.get('http://localhost:5000/api/admin/loans', {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//                 console.log('Loans response data:', response.data.data);
//                 setLoans(response.data.loans);
//             } catch (err) {
//                 console.error(err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (token) {
//             fetchLoans();
//         }
//     }, [token]);

//     const handleApprove = async (loanId) => {
//         try {
//             await axios.post(
//                 `http://localhost:5000/api/admin/loans/${loanId}/approve`,
//                 {},
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             const response = await axios.get('http://localhost:5000/api/admin/loans', {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setLoans(response.data);
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const handleReject = async (loanId) => {
//         try {
//             await axios.post(
//                 `http://localhost:5000/api/admin/loans/${loanId}/reject`,
//                 {},
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             const response = await axios.get('http://localhost:5000/api/admin/loans', {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setLoans(response.data);
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     if (loading) {
//         return <div className="text-center py-12">Loading...</div>;
//     }

//     return (
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="py-6">
//                 <div className="text-center">
//                     <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
//                     <p className="mt-2 text-gray-500">Welcome, {user?.firstName} {user?.lastName}</p>
//                     <p className="mt-2 text-gray-500">Manage loan applications</p>
//                 </div>

//                 <div className="mt-8">
//                     <div className="bg-white shadow rounded-lg p-6">
//                         <h2 className="text-xl font-semibold text-gray-900 mb-4">Pending Loans</h2>

//                         {Array.isArray(loans) && loans.length > 0 ? (
//                             <div className="space-y-4">
//                                 {loans.map((loan) => (
//                                     <div key={loan._id} className="bg-gray-50 p-4 rounded-lg">
//                                         <div className="flex justify-between items-center">
//                                             <div>
//                                                 <h3 className="text-lg font-medium text-gray-900">
//                                                     {loan.type === 'cash' ? 'Cash Loan' : 'Solar Loan'}
//                                                 </h3>
//                                                 <p className="text-sm text-gray-500">
//                                                     Amount: ₦{loan.amount.toLocaleString()}
//                                                 </p>
//                                             </div>
//                                             <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                                                 loan.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
//                                                 loan.status === 'approved' ? 'bg-green-100 text-green-800' :
//                                                 loan.status === 'repaying' ? 'bg-blue-100 text-blue-800' :
//                                                 'bg-red-100 text-red-800'
//                                             }`}>
//                                                 {loan.status}
//                                             </span>
//                                         </div>

//                                         <div className="mt-4">
//                                             <h4 className="text-sm font-medium text-gray-900">Guarantors</h4>
//                                             <div className="mt-2 space-y-2">
//                                                 {loan.guarantors.map((guarantor, index) => (
//                                                     <div key={index} className="flex justify-between items-center text-sm text-gray-500">
//                                                         <span>{guarantor.firstName} {guarantor.lastName}</span>
//                                                         <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                                                             guarantor.status === 'pending' ? 'bg-gray-100 text-gray-800' :
//                                                             guarantor.status === 'confirmed' ? 'bg-green-100 text-green-800' :
//                                                             'bg-red-100 text-red-800'
//                                                         }`}>
//                                                             {guarantor.status}
//                                                         </span>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>

//                                         <div className="mt-4 flex justify-end space-x-2">
//                                             <button
//                                                 onClick={() => handleReject(loan._id)}
//                                                 className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
//                                             >
//                                                 Reject
//                                             </button>
//                                             <button
//                                                 onClick={() => handleApprove(loan._id)}
//                                                 className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
//                                             >
//                                                 Approve
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         ) : (
//                             <div className="text-center py-8">
//                                 <p className="text-gray-500">No pending loans.</p>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div className="fixed bottom-4 right-4">
//                 <button
//                     onClick={() => {
//                         logout();
//                         navigate('/');
//                     }}
//                     className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
//                 >
//                     Logout
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default AdminDashboard;

import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from '../config/api';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const [rejectingLoanId, setRejectingLoanId] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLoans = async () => {
      try {
        const storedToken = token || localStorage.getItem("token");
        if (!storedToken) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${API_URL}/api/admin/loans`,
          {
            headers: { Authorization: `Bearer ${storedToken}` },
          }
        );

        console.log("Response data:", response.data);

        if (response.data && response.data.data && response.data.data.loans) {
          setLoans(response.data.data.loans);
        } else {
          console.warn("No loans data found in response");
          setLoans([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLoans();
  }, [token]);

  const handleApprove = async (loanId) => {
    try {
      const storedToken = token || localStorage.getItem("token");
      await axios.post(
        `${API_URL}/api/admin/loans/${loanId}/approve`,
        {},
        { headers: { Authorization: `Bearer ${storedToken}` } }
      );
      // Refresh loans after approve
      const response = await axios.get(
        `${API_URL}/api/admin/loans`,
        {
          headers: { Authorization: `Bearer ${storedToken}` },
        }
      );
      setLoans(response.data.data ? response.data.data.loans : response.data.loans || []);
    } catch (err) {
      console.error("Error approving loan:", err);
    }
  };

  const handleReject = async (loanId) => {
    // toggle reject UI for this loan
    setRejectingLoanId(loanId);
  };

  const submitReject = async (loanId) => {
    try {
      const storedToken = token || localStorage.getItem("token");
      await axios.post(
        `${API_URL}/api/admin/loans/${loanId}/reject`,
        { reason: rejectReason },
        { headers: { Authorization: `Bearer ${storedToken}` } }
      );
      // Refresh loans after reject
      const response = await axios.get(
        `${API_URL}/api/admin/loans`,
        {
          headers: { Authorization: `Bearer ${storedToken}` },
        }
      );
      setLoans(response.data.data ? response.data.data.loans : response.data.loans || []);
      setRejectingLoanId(null);
      setRejectReason('');
    } catch (err) {
      console.error("Error rejecting loan:", err);
    }
  };

  if (loading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 admin-dashboard">
      <div className="py-6">
        <div className="text-center admin-header">
          <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
          <h5 className="mt-2 text-gray-500">Welcome, {user?.firstName} {user?.lastName}</h5>
          <h6 className="mt-2 text-gray-500">Manage loan applications</h6>
        </div>
        
        {/* Summary cards */}
        <div className="row mb-3 text-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body" style={{ borderWidth: '5px', borderStyle: 'solid', borderColor: '#3490dc', borderRadius: '8px' }}>
                <h5>
                Total Customers
                </h5>
                <h1 style={{ color: '#0310c2', fontWeight: 'bold' }}>98</h1>
              </div>
            </div>
          </div>
          <div className="col-md-6 bg-red-500 text-white">
            <div className="card">
              <div className="card-body" style={{ borderWidth: '5px', borderStyle: 'solid', borderColor: '#3490dc', borderRadius: '8px' }}>
                <h5>Total Loans Disbursed</h5>
                <h1 style={{ color: '#05b31c', fontWeight: 'bold' }}>₦1,135,000</h1>
              </div>
            </div>
          </div>
          
        </div>
        <div className="mt-8">
          <div className="admin-panel">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Pending Loans</h2>

            {loans.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-gray-500">No pending loans.</p>
              </div>
            ) : (
              <div className="space-y-4">
                {loans.map((loan) => (
                  <div key={loan._id} className="loan-card">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="text-lg font-medium text-gray-900">
                          {loan.type === "cash" ? "Cash Loan" : "Solar Loan"}
                        </h3>
                        <p className="text-sm text-gray-500">
                          Amount: ₦{loan.amount.toLocaleString()}
                        </p>
                        <div className="mt-4">
                          <h4 className="text-sm font-medium text-gray-900">
                            Repayment Schedule
                          </h4>
                          <ul className="list-disc list-inside text-sm text-gray-500">
                            {loan.repaymentSchedule.map((repayment, index) => (
                              <li key={index}>
                                Due:{" "}
                                {new Date(
                                  repayment.dueDate
                                ).toLocaleDateString()}{" "}
                                — Amount: ₦{repayment.amount.toLocaleString()} —
                                Status: {repayment.status}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <p className="text-sm text-gray-500">
                          Borrower: {loan.userId?.firstName}{" "}
                          {loan.userId?.lastName}
                        </p>
                        <p className="text-sm text-gray-500">
                          Phone Number: {loan.userId?.phoneNumber}
                        </p>
                      </div>
                      <span className={`loan-badge ${loan.status === "pending" ? 'loan-pending' : loan.status === "approved" ? 'loan-approved' : loan.status === "repaying" ? 'loan-repaying' : 'loan-declined'}`}>
                        {loan.status}
                      </span>
                    </div>

                    <div className="mt-4">
                      <h4 className="text-sm font-medium text-gray-900">
                        Guarantors
                      </h4>
                      <div className="mt-2 space-y-2">
                        {loan.guarantors && loan.guarantors.length > 0 ? (
                          loan.guarantors.map((guarantor) => (
                            <div key={guarantor._id} className="guarantor-item">
                              <span>{guarantor.firstName} {guarantor.lastName}</span>
                              <p>{guarantor.phoneNumber}</p>
                              <p>{guarantor.email}</p>
                              <span className={`loan-badge ${guarantor.status === 'pending' ? 'loan-pending' : guarantor.status === 'confirmed' ? 'loan-approved' : 'loan-declined'}`}>
                                {guarantor.status}
                              </span>
                            </div>
                          ))
                        ) : (
                          <p className="text-gray-400">No guarantors available.</p>
                        )}
                      </div>
                    </div>

                    <div className="mt-4 admin-actions">
                      {rejectingLoanId === loan._id ? (
                        <div className="reject-reason-box">
                          <textarea
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter rejection reason"
                            className="reject-textarea"
                          />
                          <div className="reject-actions">
                            <button onClick={() => submitReject(loan._id)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700">Submit Rejection</button>
                            <button onClick={() => { setRejectingLoanId(null); setRejectReason(''); }} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200">Cancel</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <button onClick={() => handleReject(loan._id)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">Reject</button>
                          <button onClick={() => handleApprove(loan._id)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">Approve</button>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="fixed bottom-4 right-4">
        <button
          onClick={() => {
            logout();
            navigate("/");
          }}
          className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
